module.exports = __webpack_public_path__ + "static/media/react.68dc6cb5.png";